// extracted by mini-css-extract-plugin
export default {"container":"IconButton_container__YRYwA","icon":"IconButton_icon__+uK0X","label":"IconButton_label__IVCx7"};